import React, { useCallback, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { Col, Row } from '@yme/atoms/grid';
import { SpinnerLoader } from '@yme/atoms/spinner-loader';
import { Tabs } from '@yme/atoms/tabs';
import { useWindowSize } from '@yme/hooks/index';
import { NoResultsSearch } from '@yme/molecules/no-results-search-component';
import { SearchParams } from '@yme/utils/bloomreach';
import { useSearchPageTabs } from '../../hooks';
import { DidYouMean } from '../DidYouMean';
import { SearchPageGridSkeleton } from './SearchPageGridSkeleton';
import { getPreselectedTab } from './helpers';
import { ContainerStyled, GridWrapperStyled } from './styled';
export function SearchPageGrid({ isRightToLeft, isInitialDataLoaded, isLoading, category, query, primaryFacets, productData, contentData, autoCorrectQueryResult, didYouMeanOptions, searchResultsPageUrl, getProductData, getContentData, }) {
    const history = useHistory();
    const wrapperRef = useRef(null);
    const wrapperWidth = wrapperRef.current?.clientWidth ?? 0;
    const { isInfiniteDesktopView } = useWindowSize();
    const { tabsData } = useSearchPageTabs({
        isRightToLeft,
        primaryFacets,
        productData,
        contentData,
        query,
        wrapperWidth,
        autoCorrectQueryResult,
        getProductData,
        getContentData,
    });
    const onTabChange = useCallback(({ type }) => {
        if (type) {
            const params = new URLSearchParams();
            params.set(SearchParams.QUERY, query);
            params.set(SearchParams.CATEGORY, type);
            if (category !== type) {
                history.push({
                    search: params.toString(),
                });
            }
        }
    }, [category, history, query]);
    const isShowTabs = isInitialDataLoaded && Boolean(tabsData?.length);
    const isShowNoResults = isInitialDataLoaded && !tabsData?.length;
    return (React.createElement(React.Fragment, null,
        React.createElement(GridWrapperStyled, null,
            React.createElement(ContainerStyled, { isRightToLeft: isRightToLeft },
                React.createElement(Row, null,
                    React.createElement(Col, { ref: wrapperRef },
                        isShowTabs && (React.createElement(React.Fragment, null,
                            autoCorrectQueryResult && (React.createElement(DidYouMean, { query: query, autoCorrectQueryResult: autoCorrectQueryResult, didYouMeanOptions: didYouMeanOptions, searchResultsPageUrl: searchResultsPageUrl })),
                            React.createElement(Tabs, { isShowDropDown: !isInfiniteDesktopView, preselectedTab: getPreselectedTab(tabsData, category), tabData: tabsData, onTabChange: onTabChange }))),
                        isShowNoResults && (React.createElement(NoResultsSearch, { isHeaderNeeded: true, value: query })),
                        !isInitialDataLoaded && React.createElement(SearchPageGridSkeleton, null))))),
        React.createElement(SpinnerLoader, { isLoading: !isInitialDataLoaded || isLoading, fullWidth: true })));
}
